module.exports = __webpack_public_path__ + "static/cosmic-explorer-72cea3031df8fd102bcce100776b0595.jpg";